<template>
  <div class="cart orderList roomChargeList">
    <h1 class="boxTitle mb15 notranslate">미결제 주문</h1>
    <div v-if="list.length" class="list">
      <OrderListItem
        v-for="item in list"
        :key="item.order_id"
        :itemList="item"
        :locale="locale"
        :lang="lang" />
    </div>
    <div v-else class="noData notranslate">{{locale.order_nodata}}</div>
    <button type="button" class="btn btnFull" @click="submit">모두 결제하기</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrderListItem from '@/components/Mypage/OrderListItem'

export default {
  name: 'RoomCharge',
  props: [
    'lang',
    'locale'
  ],
  components: {
    OrderListItem
  },
  computed: {
    ...mapGetters({
      getTax: 'payment/getTax',
      metaInfo: 'authentication/getMetaInfo'
    }),
    tax () {
      return this.$store.state.payment.tax
    },
    ordersheet () {
      return this.list.map(x => x.ordersheet).flat()
    },
    totalPrice () {
      const list = this.ordersheet
      const price = list.filter(x => x.submitId !== 'tip').map(x => {
        return x.price.info.tax
          ? x.price.info.subtotal
          : x.price.info.total
      })
      const sum = (accumulator, currentValue) => accumulator + currentValue
      const total = price && price.length ? price.reduce(sum) : 0
      return price.length ? total : 0
    },
    taxPrice () {
      const total = this.totalPrice
      const taxPer = this.tax
      const tax = this.getTax(total)
      const taxTotal = total + tax
      const tipItem = this.ordersheet.find(x => x.submitId === 'tip')
      const tip = tipItem ? { tip: tipItem.price.info.total, tipLabel: 'tip' } : null
      return taxPer
        ? {
          subtotal: total,
          tax: tax,
          taxLabel: `${taxPer}%`,
          total: taxTotal,
          ...tip
        }
        : null
    }
  },
  async mounted () {
    this.$store.commit('loading', true)
    await this.getKey()
    this.$store.dispatch('submit/getOrderHistory').then((res) => {
      if (res && res.orderLog && res.paidLog) {
        const list = res.orderLog.filter(x => x.order_type && !x.order_type.includes('reservation')).map(x => {
          return {
            ...x,
            ordersheet: x.ordersheet.length ? x.ordersheet : [x.ordersheet],
            isPaid: res.paidLog.filter(p => p.orderId === x.receiptId).length > 0
          }
        }).filter(x => x.ordersheet.filter(o => o.price && o.price.info && o.price.info.total > 0).length > 0 && !x.isPaid) || []
        let tip = null
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          if (item.order_type === 'tip') {
            if (!tip) {
              tip = item
              tip.ordersheet[0].content[0] = {
                ...tip.ordersheet[0].content[0],
                order_id: tip.ordersheet[0].content[0].orderId,
                createat: tip.ordersheet[0].content[0].createat
              }
            } else {
              tip.ordersheet[0].content.push({
                ...item.ordersheet[0].content[0],
                order_id: item.ordersheet[0].content[0].orderId,
                createat: item.ordersheet[0].content[0].createat
              })
            }
          } else {
            this.list.push(item)
          }
        }
        if (tip) {
          tip.ordersheet[0].price.info = {
            ...tip.ordersheet[0].price.info,
            price: tip.ordersheet[0].content.map(x => x.price).reduce((a, b) => a + b, 0),
            tax: this.getTax(tip.ordersheet[0].content.map(x => x.price).reduce((a, b) => a + b, 0)),
            subtotal: tip.ordersheet[0].content.map(x => x.price).reduce((a, b) => a + b, 0),
            total: tip.ordersheet[0].content.map(x => x.price).reduce((a, b) => a + b, 0)
          }
        }
        this.list = this.list.concat(tip)
      }
      this.$store.commit('loading', false)
    })
  },
  data () {
    return {
      list: [],
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'orderList'
      })
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    init () {
      this.track()
    },
    submit () {
      const lang = this.$route.params.ln
      const isFrame = this.isPublic ? '&frame=false' : ''
      const returnURL = `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}#/${lang}/complete`
      const totalPrice = this.totalPrice
      const taxPrice = this.taxPrice
      const list = this.ordersheet
      const submit = {
        isArray: true,
        payload: list,
        returnURL: returnURL,
        price: {
          info: {
            ...this.priceInfo,
            total: totalPrice,
            ...taxPrice
          },
          total: taxPrice && taxPrice.total ? taxPrice.total : totalPrice
        }
      }
      this.$store.dispatch('submit/setSubmit', submit).then((res) => {
        if (res) {
          const payment = res.payment
          const paymentId = res.paymentId
          this.$router.push({
            name: 'payment',
            params: {
              ln: lang,
              payment: payment,
              paymentId: paymentId
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  text-align: center;
}
</style>
